import React from 'react'

export default ({ src, alt, ...rest }) => {
  return <img src={`${process.env.REACT_APP_API_URL}${src}`} alt={alt} {...rest} />
}
